/** Retry an unchanged snapshot idempotently; new edits need a new save identity. */
export async function snapshotForSave<T extends { requestId: string }>(
  pending: (T & { revision: number }) | null,
  revision: number,
  capture: () => Promise<T>,
): Promise<T & { revision: number }> {
  if (pending?.revision === revision) return pending;
  return { ...await capture(), revision };
}

/** Local exports and repaints do not alter Cadencia's independent savepoint. */
export function cadenciaHasUnsavedChanges(revision: number, savedRevision: number, liveEdit = false): boolean {
  return liveEdit || revision !== savedRevision;
}

/** Capture unsaved gestures before disposal cancels them and clears history. */
export function watchCadenciaSessionClose(
  session: DocumentSession,
  savedRevision: () => number,
  onClosed: (unsaved: boolean) => void,
): () => void {
  const closed = () => onClosed(cadenciaHasUnsavedChanges(session.currentRevision, savedRevision(), session.history.hasLiveCommand));
  if (session.closedSignal.aborted) closed();
  else session.closedSignal.addEventListener('abort', closed, {once:true});
  return () => session.closedSignal.removeEventListener('abort', closed);
}
import type { DocumentSession } from '../core/session';
